import store from 'lib/store';
import { ReactComponent as CloseIcon } from 'mrg-icons/src/mailru/actions/close_big.svg';
import React, { memo, ReactElement, RefObject, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { ANONYMOUS_USER_NAME } from 'reactApp/constants/magicIdentificators';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { Button } from 'reactApp/ui/Button/Button';
import Tooltip from 'reactApp/ui/Tooltip/Tooltip';
import { tooltipPlacements } from 'reactApp/ui/Tooltip/Tooltip.constants';

import styles from './FaceInfoTooltip.css';

const FACE_TIP_ID = 'faceTipViewer';

export const FaceInfoTooltip = memo(
    ({ targetRef, onApply, xOffset = 0 }: { targetRef: RefObject<HTMLDivElement>; onApply?(); xOffset?: number }): ReactElement | null => {
        const email = useSelector(UserSelectors.getEmail) || ANONYMOUS_USER_NAME;
        const showTip = !store.get(`${email}|${FACE_TIP_ID}`);
        const [show, setShow] = useState(showTip);

        const handleClose = useCallback(() => {
            setShow(false);
            store.set(`${email}|${FACE_TIP_ID}`, new Date().valueOf());
        }, []);

        const handleApply = useCallback(() => {
            onApply?.();
            handleClose();
        }, [onApply, handleClose]);

        if (!show || !targetRef?.current) {
            return null;
        }

        return (
            <Tooltip
                theme="octavius"
                target={targetRef}
                placement={tooltipPlacements.BOTTOM}
                offset={{
                    y: 4,
                    x: xOffset,
                }}
                smartPlacement={false}
                minWidth={false}
                pinned
                noPageOffset
            >
                <div className={styles.root}>
                    <div className={styles.close} onClick={handleClose}>
                        <CloseIcon />
                    </div>
                    <div className={styles.text}>
                        Облако умеет определять
                        <br />
                        людей на фото
                    </div>
                    <Button data-name="confirm" theme="octavius" className={styles.button} onClick={handleApply} fluid>
                        Попробовать
                    </Button>
                </div>
            </Tooltip>
        );
    }
);

FaceInfoTooltip.displayName = 'FaceInfoTooltip';
